import React from 'react';
import './Header.css';

interface HeaderProps {
    showSettings: boolean;
    onNavigate: () => void;
}

const Header: React.FC<HeaderProps> = ({ showSettings, onNavigate }) => {
    return (
        <header className="app-header">
            <div className="header-content">
                <h1>XRAI Session Manager</h1>
                <nav>
                    <button 
                        onClick={onNavigate} 
                        className="nav-button"
                        type="button"
                    >
                        {showSettings ? 'Sessions' : 'Settings'}
                    </button>
                </nav>
            </div>
        </header>
    );
};

export default Header;
